import React, { useCallback, useEffect, useState } from 'react';
import { TextField, Grid } from '@mui/material';

function InputField({ value, column, id, label = null, label2 = null, onChange = null, disabled = false, type = 'text', hint, required = false, ...otherProps }) {
  // Detect controlled mode based on whether value prop is explicitly provided
  const isControlled = value !== undefined;
  const [localValue, setLocalValue] = useState(value ?? '');

  // Use controlled value if value prop is provided, otherwise use local state
  const inputValue = isControlled ? (value ?? '') : localValue;

  const handleInputChange = useCallback(
    (e) => {
      if (!isControlled) {
        // In uncontrolled mode, update local state
        setLocalValue(e.target.value);
      }

      // Always notify parent if callback provided
      if (typeof onChange === 'function') {
        onChange(e);
      }
    },
    [isControlled, onChange],
  );

  // Sync local state when value prop changes (for uncontrolled mode)
  useEffect(() => {
    if (!isControlled && value !== undefined) {
      setLocalValue(value);
    }
  }, [value, isControlled]);

  return (
    <Grid size={Number(column)}>
      <span>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
        <i>
          <small> {label2}</small>
        </i>
      </span>
      <TextField
        type={type}
        id={id}
        key={id}
        value={inputValue}
        disabled={disabled}
        helperText={hint}
        onChange={handleInputChange}
        variant="outlined"
        size="small"
        fullWidth
        {...otherProps}
        slotProps={{
          formHelperText: { sx: { ml: 0 } },
        }}
      />
    </Grid>
  );
}

export default InputField;
